import { Option } from "@components/hook-form/RHFAutocomplete";

export const formatPeppolOptions = (options: any[] | undefined): Option[] => {
  return (options || []).map((opt: any) => ({
    label: `Company ID (${opt.companyId || "N/A"}), Scheme ID (${
      opt.schemeId || "N/A"
    }), Peppol Participant ID (${
      opt.peppolParticipantId || "N/A"
    }), Country (${opt.country || "N/A"})`,
    value: opt.peppolParticipantId || "",
  }));
};